import Vue from 'vue'
import Vuex from 'vuex'
import RandomSeed from 'random-seed'
import Seed from './seed'
import StoryBuilder from 'story-builder'
import Markov from 'markov-strings'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    generators: [],
    generatorRunners: {},
    common: {},
    isFullyLoaded: false
  },
  mutations: {
    updateGenerators (state, generators) {
      state.generators = generators
    },
    saveGenerator (state, generator) {
      state.generators.push(generator)
      state.generatorRunners = generator
    },
    common (state, common) {
      state.common = common
    },
    isFullyLoaded (state) {
      state.isFullyLoaded = true
    }
  },
  actions: {
    loadGenerator (state, generatorData) {
      state.commit('saveGenerator', generatorData)
    }
  },
  modules: {
  },
  getters: {
    fullyLoaded: state => state.isFullyLoaded,
    generators: state => {
      return state.generators
    },
    markov: state => (generatorName, mySeed) => {
      const theSeed = Seed(mySeed)
      const rand = RandomSeed.create(theSeed)
      const generator = state.generators.filter(u => u.name === generatorName.toLowerCase())[0]
      if (!generator) {
        console.log('could not find generator')
        return null
      }
      const markovTitle = new Markov({ stateSize: 2 })
      const markovDescription = new Markov({ stateSize: 1 })
      markovTitle.addData(generator.data[generator.display.title])
      markovDescription.addData(generator.data[generator.display.description])
      const options = {
        maxTries: 30,
        prng: () => rand.random(),
        filter: result => {
          return (result.string.split(' ').length > 3) && result.string.endsWith('.')
        }
      }
      const result = {
        title: markovTitle.generate({ maxTries: 30, prng: () => rand.random(), filter: r => true }).string,
        description: markovDescription.generate(options).string,
        sections: []
      }

      return {
        rand,
        result,
        seed: theSeed
      }
    },
    story: state => (generatorName, mySeed) => {
      const theSeed = Seed(mySeed)
      const rand = RandomSeed.create(theSeed)
      const builder = new StoryBuilder()
      const generator = state.generators.filter(u => u.name === generatorName.toLowerCase())[0]
      if (!generator) {
        console.log('could not find generator')
        return null
      }
      builder.loadDataset(state.common)
      try {
        builder.loadDataset(generator.data)
      } catch (e) {
        console.error(e)
      }
      let variables = {}
      const result = {
        sections: []
      }
      {
        const p = builder.build(generator.display.title, rand, variables)
        result.title = p.text
        variables = p.variables
      }
      if (generator.display.description) {
        const p = builder.build(generator.display.description, rand, variables)
        result.description = p.text
        variables = p.variables
      } else {
        result.description = ''
      }
      generator.display.sections.forEach(part => {
        const p = builder.build(part.generate, rand, variables)
        result.sections.push({
          heading: part.heading,
          text: p.text
        })
        variables = p.variables
      })
      return {
        result,
        seed: theSeed
      }
    }
  }
})
